export const accountingRoutes = {
  getInfo: '/api/v1/accounting/:id',
  getInvoice: '/api/v1/accounting/invoice/:id',
  getPdfInvoice: '/api/v1/accounting/invoiceDoc/:id',
  getPdfPOD: '/api/v1/accounting/podDoc/:id',
}
